import { cn } from "@wags/ui/ui-utils";
import {
    SECONDARY_RAIL_CLASS,
    SECONDARY_RAIL_ITEM_CLASS,
} from "@/components/shared/dogCardGrid";
import { DogCard } from "@/features/listings";
import type { ProviderDogListingCard } from "./provider-listing-card";

export function adoptedCardsWithPhotos(cards: ProviderDogListingCard[]) {
    return cards.filter((card) => card.imageUrl);
}

export function AdoptedDogCards({
    cards,
    className,
}: {
    cards: ProviderDogListingCard[];
    className?: string;
}) {
    return (
        <div className={cn("scroll-fade-x", SECONDARY_RAIL_CLASS, className)}>
            {cards.map((card) => (
                <div key={card.id} className={SECONDARY_RAIL_ITEM_CLASS}>
                    <DogCard
                        measurementSurface="provider"
                        variant="overlay"
                        id={card.id}
                        name={card.name}
                        imageUrl={card.imageUrl}
                        breedNames={card.breedNames}
                        status={card.status ?? "unavailable"}
                        priceRange={card.priceRange}
                    />
                </div>
            ))}
        </div>
    );
}

export function RecentlyAdoptedSection({
    cards,
    className,
}: {
    cards: ProviderDogListingCard[];
    className?: string;
}) {
    const withPhotos = adoptedCardsWithPhotos(cards);
    if (withPhotos.length < 2) return null;

    return (
        <section className={cn("w-full", className)}>
            <h2 className="text-section-title text-doberman-black">
                Recently found homes
            </h2>
            <AdoptedDogCards cards={withPhotos} className="mt-5" />
        </section>
    );
}
